import { useEffect } from 'react';
export const useOutsideClick = (ref, callback, excludeClassName) => {
    useEffect(() => {
        const listener = (event) => {
            if (ref === null) {
                return;
            }
            const refObj = ref instanceof HTMLElement ? ref : ref.current;
            if (!refObj || refObj.contains(event.target)) {
                return;
            }
            if (excludeClassName &&
                (event.target.classList.contains(excludeClassName) ||
                    event.target.closest(`.${excludeClassName}`))) {
                return;
            }
            callback(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, callback]);
};
//# sourceMappingURL=useOutsideClick.js.map